<template>
  <div :class="{contentWrap:true,noNav:$store.state.isWx}">
    <div class="container">
      <van-nav-bar
        :title="title"
        v-if="!$store.state.isWx"
        fixed
        left-arrow
        @click-left="$router.go(-1)"
      />
      <scroll>
        <div class="content">
          <van-tabs ref="tabsMain" v-model="typeRadio" swipeable class="clear chosetype">
            <van-tab ref="tabFirst" title="按身份证号码"  disabled v-show="false"></van-tab>
            <van-tab title="按订单号码"></van-tab>
            <van-tab title="按票号" disabled v-show="false"></van-tab>
          </van-tabs>
          <van-cell-group>
            <van-field
              v-show="typeRadio==0"
              v-model="addInvoice.ticketNumber"
              clearable
              label="身份证"
              maxlength="18"
              @blur="vertifyIdCard"
              :error-message="idCardErrorMsg"
              placeholder="请输入您身份证号码"
              class="pdt-3 pdb-3"
            />
            <van-field
              v-show="typeRadio == 1"
              v-model="addInvoice.phone"
              clearable
              label="手机号"
              maxlength="11"
              @blur="vertifyphone"
              :error-message="phoneErrorMsg"
              placeholder="请输入手机号"
              class="pdt-3 pdb-3"
            />
            <van-field
              v-show="typeRadio==1"
              v-model="addInvoice.orderNumber"
              clearable
              label="订单号"
              maxlength="17"
              @blur="orderIsRight"
              :error-message="orderErrorMsg"
              placeholder="请输入您要开票的订单号码"
              class="pdt-3 pdb-3"
            />
            <van-field
              v-show="typeRadio==2"
              v-model="addInvoice.ticketNumber"
              clearable
              label="票号"
              @blur="ticketIsRight"
              :error-message="ticketErrorMsg"
              placeholder="请输入您要开票的票号"
              class="pdt-3 pdb-3"
            />
          </van-cell-group>

          <div class="buttonWrap">
            <van-button type="primary" @click="getInvoice">开票</van-button>
            <div style="padding: .5rem 0">
              <span class="van-tag van-tag--plain van-tag--medium" style="color:#F60" >
                您好，开具发票需要一定的时间，请开票完成后3~5
                分钟内查询
              </span>
            </div>
          </div>
        </div>
        <div class="copyright">
          <p>Copyright(C) 2020－2021 ectrip.com All Rights Reserved.</p>
          <p>发票服务热线：0514-87357803</p>
        </div>
      </scroll>
    </div>
  </div>
</template>
<script>
export default {
  name: "CreateReceipt",
  data() {
    return {
      typeRadio: 2,
      title: this.$route.meta.title,
      addInvoice: {
        phone: "",
        orderNumber: "",
        ticketNumber: "",
      },
      phoneErrorMsg: "",
      orderErrorMsg: "",
      ticketErrorMsg: "",
      idCardErrorMsg: "", //身份证
    };
  },
  mounted() {
    //console.log(this.$refs.tabFirst)
    // console.log( this.$refs.tabsMain.$refs)
    //let mm=this.$refs.tabsMain.$el.getElementsByClassName("van-tab--disabled")
    //mm.getElementsByClassName("van-tab--disabled")[0].display='none'
    //console.log( this.$refs.tabsMain.$refs.nav.childNodes)

    //let a =this.$refs.tabsMain.$refs.nav.childNodes

    //console.log( a)
    //a[0].getElementsByClassName("van-tab--disabled").style.display='none'
    //只有$el下面的dom 才可以操作 ！！！

    let t = this.$refs.tabsMain.$el.childNodes;
    let self = this;
    setTimeout(function () {
      t[0].getElementsByClassName("van-tab--disabled")[0].style.display =
        "none";
      t[0].getElementsByClassName("van-tab--disabled")[1].style.display =
        "none";
      self.typeRadio = 1;
    }, 10);
  },
  methods: {
    // 验证身份证
    vertifyIdCard() {
      if (this.typeRadio === 0) {
        let myreg = /^[1-9][0-9]{17}$/;
        this.idCardErrorMsg = "";
        if (!myreg.test(this.addInvoice.ticketNumber)) {
          this.idCardErrorMsg = "身份证输入错误";
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    // 验证手机号
    vertifyphone() {
      if (this.typeRadio === 1) {
        let myreg = /^[1][1-9][0-9]{9}$/;
        this.phoneErrorMsg = "";
        if (!myreg.test(this.addInvoice.phone)) {
          this.phoneErrorMsg = "手机号输入错误";
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    orderIsRight() {
      if (this.typeRadio === 1) {
        this.orderErrorMsg = "";
        if (this.addInvoice.orderNumber === "") {
          this.orderErrorMsg = "订单号不能为空";
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    ticketIsRight() {
      if (this.typeRadio === 2) {
        this.ticketErrorMsg = "";
        if (this.addInvoice.ticketNumber === "") {
          this.ticketErrorMsg = "票号不能为空";
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getInvoice() {
      this.vertifyphone() &&
        this.ticketIsRight() &&
        this.orderIsRight() &&
        this.ajaxData();
    },
    async ajaxData() {
      const parmas = {
        savetype:
          this.typeRadio === 0 ? "02" : this.typeRadio === 1 ? "01" : "02",
        typeRadio: this.typeRadio,
        orid:
          this.typeRadio === 1
            ? this.addInvoice.orderNumber
            : this.addInvoice.ticketNumber,
        moblie: this.typeRadio === 1 ? this.addInvoice.phone : "",
      };
      const data = await this.$http.addInvoiceSearch(parmas);
      if (data.status === "error") {
        alert(data.message);
      } else {
        if (this.typeRadio === 1) {
          data.data[0].phone = this.addInvoice.phone;
        }
        if (this.typeRadio !== 0) {
          data.data[0].typeRadio = this.typeRadio;
          data.data[0]["vtype"] = this.typeRadio === 1 ? "01" : "02";
        }

        //重新组装data数据为数组
        let newDataArr = [];
        if (this.typeRadio === 0) {
          for (let m in data.data) {
            data.data["" + m + ""].typeRadio = this.typeRadio;
            data.data["" + m + ""][0].typeRadio = this.typeRadio;
            data.data["" + m + ""][0].orid = m;
            data.data["" + m + ""][0].phone = "";
            data.data["" + m + ""][0]["vtype"] = "01";
            data.data["" + m + ""][0]["ticketCount"] =
            data.data["" + m + ""][0]["totalcount"];
            newDataArr.push(data.data["" + m + ""]);
          }
        } else {
          newDataArr[0] = data.data;
        }

        //console.log(newDataArr)

        this.$router.push(`/invoiceAdd?data=${JSON.stringify(newDataArr)}&phone=${this.addInvoice.phone}`);
      }
    },
  },
};
</script>
<style scoped>
.typeWrap {
  line-height: 0.8rem;
  font-size: 0.24rem;
  text-align: center;
  border-bottom: 1px solid gainsboro;
}

.copyright {
  margin-top: 0.3rem;
  padding-top: 0.1rem;
  border-top: 0.02rem solid #d7d7d7;
  font-size: 0.2rem;
  color: #9ca5a9;
  text-align: center;
  line-height: 0.45rem;
}

.circle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle > div {
  margin-right: 5px;
  border-radius: 20px;
  border: 1px solid #c0c0c0;
  width: 20px;
  height: 20px;
  transition: all 0.5s ease-in-out;
  line-height: 20px;
}

.circle > .active i {
  display: inline;
}

.circle > div i {
  display: none;
  color: white;
}

.active {
  background-color: green;
}
</style>


// WEBPACK FOOTER //
// src/page/InvoiceAddSearch.vue